import React from 'react';
import PropTypes from 'prop-types';

export default function Loader({ children = '' }) {
  return (
    <div className="loader">
      <img alt="Envisio" className="envisio-logo" src={`//${window.location.host}/img/envisio-loading.svg`} />
      <strong>{children}</strong>
    </div>
  );
}

Loader.propTypes = { children: PropTypes.node };
